<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Pré Vendas</h1>
        <p class="text-sm text-gray-500">Gerencie suas pré-vendas</p>
      </div>
      <button (click)="openPdvPreVendas()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        PDV Pré-Vendas
      </button>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-6 gap-4">
    <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()" placeholder="Buscar por nome ou código..." class="border border-gray-300 rounded px-3 py-2 text-sm" />
      
    <p-dropdown
          [options]="status"
          [(ngModel)]="selectedStatus"
          (onChange)="onStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>


        <div class="flex items-center">
          <p-datepicker [(ngModel)]="initialDate" (onSelect)="onStatusChange()" dateFormat="dd/mm/yy" />
        </div>
        <div class="flex items-center">
          <p-datepicker [(ngModel)]="finalDate" (onSelect)="onStatusChange()" dateFormat="dd/mm/yy" />
        </div>

      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} pré-venda(s) encontrada(s)
      </div>

      <div class="flex justify-end">
        <p-button (onClick)="export()" label="Exportar"></p-button>
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="preVendas" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Data</th>
            <th class="text-left px-6 py-3">Cliente</th>
            <th class="text-left px-6 py-3">Desconto (R$)</th>
            <th class="text-left px-6 py-3">Total</th>
            <th class="text-left px-6 py-3">Total Líquido</th>
            <th class="text-left px-6 py-3">Status</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-preVenda let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ preVenda.id }}</td>
            <td class="px-6 py-2 text-gray-900">{{ preVenda.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="px-6 py-2 text-gray-900">{{ preVenda.customerName || 'Não informado' }}</td>
            <td class="px-6 py-2 text-red-500 font-medium">R$ {{ preVenda.discount | number: '1.2-2' }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">R$ {{ preVenda.grossTotal | number: '1.2-2' }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">R$ {{ preVenda.netTotal | number: '1.2-2' }}</td>

            <td class="px-6 py-2" [ngClass]="{'text-gray-900': preVenda.status !== 'Cancelado', 'text-red-500': preVenda.status === 'Cancelado'}">
              {{ preVenda.status || 'Ativa' }}
            </td>
            
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Visualizar"
                  icon="pi pi-eye"
                  text
                  severity="secondary"
                  (click)="view(preVenda)">
                </p-button>
                <p-button
                  pTooltip="Cancelar"
                  icon="pi pi-times-circle"
                  text
                  severity="secondary"
                  (click)="cancel(preVenda)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="text-center py-8 text-gray-500">
              Nenhuma pré-venda encontrada
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>


    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>

  </div>
  <div class="flex fixed bottom-0 w-full bg-white border-gray-500 px-6 py-4 items-around text-sm z-20">
  </div>
</div>
<p-confirmDialog></p-confirmDialog>
<p-toast />
